const STORAGE_PREFIX = 'happydigital-draft-post.draft.';

function storageKey(userId) {
  return STORAGE_PREFIX + userId;
}

/**
 * Read the one browser-local draft belonging to this user.
 */
export function loadLocalDraft(userId) {
  const stored = localStorage.getItem(storageKey(userId));

  if (!stored) return null;

  try {
    const draft = JSON.parse(stored);

    if (!draft || typeof draft !== 'object') return null;

    return {
      title: typeof draft.title === 'string' ? draft.title : '',
      content: typeof draft.content === 'string' ? draft.content : '',
    };
  } catch (error) {
    // A corrupt or manually edited value must not prevent the composer opening.
    return null;
  }
}

/**
 * Store one global draft per signed-in user in this browser.
 */
export function saveLocalDraft(userId, title, content) {
  localStorage.setItem(
    storageKey(userId),
    JSON.stringify({
      title: title || '',
      content: content || '',
    })
  );
}

export function deleteLocalDraft(userId) {
  localStorage.removeItem(storageKey(userId));
}
